<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        :height="height" :class="classes" class="fill-current">
        <path d="M19,21H5V9H2V3h6.519l0.301,0.398C9.575,4.401,10.765,5,12,5s2.425-0.599,3.181-1.602L15.481,3H22v6h-3V21z M7,19h10v-2H7 V19z M7,15h10V7h3V5h-3.55C15.317,6.261,13.689,7,12,7S8.683,6.261,7.55,5H4v2h3V15z"/>
    </svg>
</template>

<script>
export default {
    props: [ 'height', 'classes' ]
}
</script>